import {Injectable} from "@angular/core";
import {CacheById} from "@shared/data-stores/cache-by-id";
import {DeviceObject} from "@app/graphql-typings/graphql";
import {map} from "rxjs/operators";
import {CollectionUtils} from "@shared/util/collections/collection-utils";
import {Observable} from "rxjs";
import {DeviceObjectId} from "@shared/util/app-types";
import {BacerDevicesService} from "@app/layout/sitemanager/bacers/bacer-devices/bacer-devices.service";

@Injectable()
export class BacnetDeviceObjectCache {
  private readonly deviceObjectsByIdCache: CacheById<DeviceObjectId, DeviceObject>;

  constructor(deviceService: BacerDevicesService) {
    this.deviceObjectsByIdCache = new CacheById((deviceObjectIds: DeviceObjectId[]) =>
      deviceService.getAllDeviceObjects({device_object_ids: deviceObjectIds}, {getDevice: true}).pipe(
        map(deviceObjects => CollectionUtils.indexBy(deviceObjects, 'device_object_id'))));
  }

  getDeviceObjectsByIds(deviceObjectIds: DeviceObjectId[]): Observable<Map<DeviceObjectId, DeviceObject>> {
    return this.deviceObjectsByIdCache.getByIds(deviceObjectIds);
  }
}
